import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { LeaseChartOfAccountSettings } from '~/swagger/settings/Api';

const CHART_OF_ACCOUNT_SETTINGS_URL = `${envConfig.service.settings}/company-portal/settings/leasechartofaccount`;

export class chartOfAccountSettingRepository extends BaseRestRepository {
  public async addChartOfAccountSettings(payload: LeaseChartOfAccountSettings) {
    const url = `${CHART_OF_ACCOUNT_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
      }),
    });
    return this.getJsonResponse(response);
  }

  public async addChartOfAccountSettingsByLevel(level: string, levelId: string, payload: LeaseChartOfAccountSettings) {
    const url = CHART_OF_ACCOUNT_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async getChartOfAccountSettings(): Promise<LeaseChartOfAccountSettings> {
    const url = `${CHART_OF_ACCOUNT_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getChartOfAccountSettingsByLevel(level: string, levelId: string) {
    const url = `${CHART_OF_ACCOUNT_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getAllChartOfAccountSettings(): Promise<LeaseChartOfAccountSettings> {
    const url = `${CHART_OF_ACCOUNT_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }
}
